module.exports = __webpack_public_path__ + "img/whiteCalendar.fc724018.svg";